/**
 * Het versienummer van Arch-designer: één nummer voor web-app, worker,
 * desktop-app, MCP-server en iPad-app. `pnpm release <versie>` zet het hier
 * en in de package.json's; met de hand aanpassen hoeft niet.
 *
 * Patch (0.9.1) is een bugfix, minor (0.10.0) nieuwe functionaliteit, major
 * (1.0.0) een wijziging waar oudere apps niet meer mee werken.
 */
export const APP_VERSION = "0.9.0";

/**
 * De oudste app-versie die deze server nog bedient. Een oudere desktop- of
 * iPad-app meldt dan "verouderd" in plaats van onbegrijpelijke fouten. Alleen
 * ophogen bij een wijziging die oudere apps breekt.
 */
export const MIN_CLIENT_VERSION = "0.9.0";

/** Antwoord van `GET /api/v1/version` (openbaar). */
export interface ServerVersion {
  product: "arch-designer";
  /** Welke routes er zijn (los van het productnummer); de iPad-app leest dit. */
  api_version: number;
  version: string;
  /** Korte commit en datum van de build; "dev" als die onbekend zijn. */
  build: { commit: string; date: string };
  min_client_version: string;
  /**
   * Het publieke adres (`PUBLIC_ORIGIN`). Opent iemand de web-app op een
   * ander adres, dan stuurt die door; `null` als het niet ingesteld is.
   */
  public_origin: string | null;
}

/** Vergelijkt "major.minor.patch": negatief als a ouder is dan b. */
export function compareVersions(a: string, b: string): number {
  const parts = (v: string) => v.split(/[.-]/, 3).map((p) => Number.parseInt(p, 10) || 0);
  const [pa, pb] = [parts(a), parts(b)];
  for (let i = 0; i < 3; i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (d !== 0) return d;
  }
  return 0;
}

/** Of een app van versie `client` te oud is voor deze server. */
export function clientIsOutdated(client: string, server: ServerVersion): boolean {
  return compareVersions(client, server.min_client_version) < 0;
}

/** "0.9.0 · 2026-10-25 · fed7eb5", zonder de onbekende delen. */
export function versionLabel(version: string, build?: { commit: string; date: string }): string {
  return [version, build?.date, build?.commit].filter((p) => p && p !== "dev").join(" · ");
}
